import { Box, Collapse, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import CustomCollapseButton from '@/components/global/buttons/CustomCollapseButton.jsx';
import CommentBubble from '@/components/global/fields/CommentBubble';
import { collapsibleSectionStyles } from '@/themes/commonStyles/collapsibleSection';

const StyledCollapsibleSection = styled(Box)(collapsibleSectionStyles);

const CollapsibleSection = ({ title, isOpen, onToggle, children, headerContent = null, commentCount = null, className = '' }) => {
    const sectionClassName = ['popup-wrapper', 'collapsible-section', isOpen ? 'collapsible-section--open' : 'collapsible-section--closed', className]
        .filter(Boolean)
        .join(' ');

    return (
        <StyledCollapsibleSection className={sectionClassName}>
            <Box className='popup-box popup-box--header' onClick={onToggle}>
                <Box className='collapsible-section__title'>
                    <Typography variant='h5'>{title}</Typography>
                    {commentCount !== null && <CommentBubble count={commentCount} />}
                </Box>
                {headerContent}
                <Box>
                    <CustomCollapseButton isOpen={isOpen} />
                </Box>
            </Box>
            <Collapse in={isOpen}>
                <Box className='padding-wrapper'>
                    <Box className='padding-wrapper-inner'>{children}</Box>
                </Box>
            </Collapse>
        </StyledCollapsibleSection>
    );
};

CollapsibleSection.propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    headerContent: PropTypes.node,
    commentCount: PropTypes.number,
    className: PropTypes.string,
};

export default CollapsibleSection;
